(function () {

  function setBtnState(btn, state) {
    btn.classList.remove("is-loading", "is-added", "is-error");

    if (state === "loading") btn.classList.add("is-loading");
    if (state === "added") btn.classList.add("is-added");
    if (state === "error") btn.classList.add("is-error");

    btn.disabled = state === "loading";
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return await res.json();
  }

  function updateCartBubble(itemCount) {
    const selectors = [
      "[data-cart-count]",
      ".cart-count-bubble span",
      ".header__icon--cart .cart-count-bubble span",
      ".cart-count-bubble"
    ];

    const nodes = [];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(n => nodes.push(n));
    });

    const unique = [...new Set(nodes)];

    unique.forEach(node => {
      if (node.classList && node.classList.contains("cart-count-bubble")) {
        const span = node.querySelector("span");
        if (span) span.textContent = itemCount;
        else node.textContent = itemCount;
        node.style.display = itemCount > 0 ? "" : "none";
      } else {
        node.textContent = itemCount;
      }
    });
  }

  async function refreshCartUI() {
    try {
      const cart = await getCart();
      updateCartBubble(cart.item_count);

      document.dispatchEvent(new CustomEvent("cart:update", { detail: cart }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
    } catch (e) {
      console.warn("Cart refresh failed", e);
    }
  }

  async function addToCart(variantId, quantity) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Number(quantity)
      })
    });

    if (!res.ok) {
      const t = await res.text();
      throw new Error(t || "Add to cart failed");
    }

    return await res.json();
  }

  function initQuickAdds(root) {
    root.querySelectorAll(".collection-quickadd").forEach(wrap => {

      if (wrap.dataset.qaInit === "1") return;
      wrap.dataset.qaInit = "1";

      const minus = wrap.querySelector('[data-qa="minus"]');
      const plus = wrap.querySelector('[data-qa="plus"]');
      const qty = wrap.querySelector('[data-qa="qty"]');
      const add = wrap.querySelector('[data-qa="add"]');

      if (!add) return;

      function getQty() {
        if (qty) {
          const v = parseInt(qty.value, 10);
          return Number.isFinite(v) && v > 0 ? v : 1;
        }
        return 1;
      }

      add.addEventListener("click", async () => {
        const variantId = wrap.dataset.variantId;
        const quantity = getQty();

        const originalText = add.textContent;

        setBtnState(add, "loading");
        add.textContent = "Adding…";

        try {
          await addToCart(variantId, quantity);
          await refreshCartUI();

          setBtnState(add, "added");
          add.textContent = "Added ✓";

          setTimeout(() => {
            setBtnState(add, "idle");
            add.textContent = originalText;
          }, 900);

        } catch (e) {
          console.warn(e);
          setBtnState(add, "error");
          add.textContent = "Error";

          setTimeout(() => {
            setBtnState(add, "idle");
            add.textContent = originalText;
          }, 1200);
        }
      });

    });
  }

  document.addEventListener("DOMContentLoaded", () => initQuickAdds(document));
  document.addEventListener("shopify:section:load", e => initQuickAdds(e.target || document));

})();
